var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.613,
    height: 20.613,
    viewBox: "0 0 20.613 20.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M255.1,252.831l-4.766-4.766a.315.315,0,0,1,.059-.491L254,245.387a.315.315,0,0,0-.075-.571l-12.32-3.6a.315.315,0,0,0-.39.39l3.6,12.319a.315.315,0,0,0,.571.075l2.187-3.611a.315.315,0,0,1,.491-.059l4.766,4.766a.315.315,0,0,0,.445,0l.911-.911.911-.911a.315.315,0,0,0,0-.445",
    transform: "translate(-234.577 -234.577)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M7.012,13.913a6.4,6.4,0,1,1,6.9-6.9.569.569,0,1,0,1.135-.092A7.538,7.538,0,1,0,6.92,15.048l.047,0a.569.569,0,0,0,.046-1.137",
    transform: "translate(0 -0.001)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M97.33,91.757a3.945,3.945,0,0,1,.992,1.664.569.569,0,0,0,1.092-.323,5.078,5.078,0,1,0-6.421,6.282.569.569,0,0,0,.347-1.084,3.9,3.9,0,0,1-1.581-.966,3.94,3.94,0,0,1,5.571-5.572",
    transform: "translate(-87.01 -87.009)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechIcon);
export default __webpack_public_path__ + "static/media/speech-icon.9bbb5082476fedddb0b1353c1a47761e.svg";
export { ForwardRef as ReactComponent };